<template>
    <app-layout>
        <asset-details-header />
        <div class="py-6">
            <test-records />
        </div>
        <attachments-modal />
    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import TestRecords from '@/Components/TestRecords.vue';
import AssetDetailsHeader from '@/Pages/Assets/Details/AssetDetailsHeader.vue';
import AttachmentsModal from '@/Components/AttachmentsModal.vue';

export default {
    components: {
        AttachmentsModal,
        AppLayout,
        TestRecords,
        AssetDetailsHeader,
    },

    computed: {
        asset() {
            return this.$page.props.asset;
        },
    },
};
</script>
